var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUsersHeader(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#004FFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Path_9711",
    className: "st0",
    d: "M22.2601109,4.3246717h-0.0098553H22.2601109z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9719",
    className: "st0",
    d: "M20.370924,16.7960587c-1.2553463-0.6923962-2.6660061-1.0545578-4.0996418-1.0525045 h-2.5130005c-4.6126947,0.0178194-8.347908,3.7521524-8.3668165,8.3648443v1.1934299 c0.0021715,1.6602154,1.3475013,3.0055466,3.0077181,3.0077171h13.2055759 c1.6383476-0.0119553,2.9692822-1.3262844,3.0018044-2.9643555v-1.6447849h0.0019722 c-0.1095009-2.3083286-1.1701736-4.4682102-2.9298649-5.9661598C21.2643375,17.3924789,20.8274307,17.0790405,20.370924,16.7960587 z M22.5823669,24.1083984v1.1934299c0,0.5393715-0.4372482,0.9766197-0.9766216,0.9766197H8.3991833 c-0.5393729,0-0.9766212-0.4372482-0.9766216-0.9766197v-1.1934299c0.0070581-3.5006809,2.8448915-6.3358669,6.3455753-6.3396626 h2.5189133c3.4783821,0.0361156,6.2818546,2.861105,6.2913742,6.3396626H22.5823669z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.0058947,1.6904552C11.2909355,1.691538,8.2799683,4.7034078,8.2799683,8.4184265 c-0.0006018,3.7151985,3.0107269,6.7273693,6.7259264,6.7279119c0.0013227,0,0.0026464,0,0.0039701,0 c3.7157402-0.0010843,6.7270679-3.0141563,6.7259865-6.7298965C21.7347679,4.7007008,18.7216358,1.6893719,15.0058947,1.6904552z  M15.0078802,13.2035656c-2.6427927,0-4.7852001-2.1423473-4.7852001-4.7851391s2.1424074-4.7852001,4.7852001-4.7852001 s4.7851992,2.1424077,4.7851992,4.7852001S17.650671,13.2035656,15.0078802,13.2035656z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsersHeader);
export default __webpack_public_path__ + "static/media/icon_users_header.76015765ef456c2d67645cc8b00a4c83.svg";
export { ForwardRef as ReactComponent };